import React from 'react'
import BusinessHero from './businessHero/BusinessHero'
import BusinessData from './businessData/BusinessData'
import BusinessTestimonial from './businessTestimonial/BusinessTestimonial'
import BusinessService from './businessService/BusinessService'
import BusinessDrive from './businessDrive/BusinessDrive'
import BusinessScale from './businessScale/BusinessScale'
import BusinessBenefit from './businessBenefit/BusinessBenefit'
import BusinessSmarter from './businessSmarter/BusinessSmarter'
import BusinessIndustry from './businessIndustry/BusinessIndustry'

export default function Business() {
  return (
    <div>
        <BusinessHero/>
        <BusinessData/>
        <BusinessScale/>
        <BusinessSmarter/>
        <BusinessIndustry/>
        <BusinessBenefit/>
        <BusinessDrive/>
        <BusinessTestimonial/>
        <BusinessService/>
    </div>
  )
}
